import React, { useEffect, useRef, useState } from 'react'
import { Container } from './Container'
import logo from '../../assets/images/logo.jpeg';
import { useNavigate } from 'react-router-dom';

// Complete feature list - do not abbreviate this array
const features = [
  {
    name: 'Segregation of Duties Rulesets',
    description: 'Define and enforce customized SoD rules across your enterprise. Automatically detect and report violations, track remediation, and maintain compliance.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
      </svg>
    ),
  },
  {
    name: 'AI-Powered Policy Library',
    description: 'Maintain a comprehensive library of policies with AI-assisted creation, review, and distribution. Automatically link policies to controls and risks.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
      </svg>
    ),
  },
  {
    name: 'Audit Request Management',
    description: 'Streamline the process of requesting and receiving information from auditees with automated workflows, tracking, and escalations.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859" />
      </svg>
    ),
  },
  {
    name: 'Integrated Process Narratives',
    description: 'Connect system owner input with audit documentation through AI-generated process narratives that automatically identify key controls and risks.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
      </svg>
    ),
  },
  {
    name: 'Direct ERP Integration',
    description: 'Connect directly to your ERP systems to automatically extract and analyze data, eliminating manual exports and spreadsheet manipulation.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
      </svg>
    ),
  },
  {
    name: 'Risk Monitoring & Alerts',
    description: 'Continuously monitor identified risks and automatically alert relevant stakeholders when risk levels change or control failures occur.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
      </svg>
    ),
  },
  {
    name: 'AI-Based Testing Automation',
    description: 'Leverage AI to design, execute, and evaluate control tests, dramatically reducing manual effort while improving consistency and coverage.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 1-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21a48.309 48.309 0 0 1-8.135-1.187c-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
      </svg>
    ),
  },
  {
    name: 'Audit Evidence Repository',
    description: 'Store, organize, and retrieve audit evidence with powerful search capabilities and automatic linking to controls and findings.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
      </svg>
    ),
  },
  {
    name: 'Policy Compliance Tracking',
    description: 'Monitor adherence to policies across your organization with automated assessments and reporting on policy compliance status.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296a3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
      </svg>
    ),
  },
]

export function SecondaryFeatures() {
  // Debug log to check features  
  console.log("Features array length:", features.length);
  
  // Navigation hook for routing
  const navigate = useNavigate();
  
  // Reference to the logo container for dynamically adding the logo
  const logoContainerRef = useRef(null);
  
  // Refs for each card to track visibility
  const cardRefs = useRef([]);
  
  // State to track which cards are visible
  const [visibleCards, setVisibleCards] = useState({});
  
  // State to track if we're on mobile
  const [isMobile, setIsMobile] = useState(false);

  // Function to handle the "Explore Feature" click
  const handleExploreClick = (e) => {
    e.preventDefault();
    navigate('/register');
  };

  // Setup intersection observer for card animations
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 // When 10% of the card is visible
    };

    const handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Get the card index from the element's dataset
          const index = entry.target.dataset.index;
          
          // Update state to mark this card as visible
          setVisibleCards(prev => ({
            ...prev,
            [index]: true
          }));
          
          // Stop observing once it's been revealed
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    
    // Observe all card elements
    cardRefs.current.forEach(card => {
      if (card) {
        observer.observe(card);
      }
    });

    return () => {
      if (cardRefs.current) {
        cardRefs.current.forEach(card => {
          if (card) {
            observer.unobserve(card);
          }
        });
      }
    };
  }, []);
  
  // Handle screen size changes
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 640);
    }
    
    // Set initial value
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Effect to add logo to the SVG after component mounts with improved visibility
  useEffect(() => {
    // Add the logo to the container if the ref is available
    if (logoContainerRef.current) {
      // Create a simple container to center the logo
      const container = document.createElement('div');
      container.style.width = '100%';
      container.style.height = '100%';
      container.style.display = 'flex';
      container.style.alignItems = 'center';
      container.style.justifyContent = 'center';
      container.style.backgroundColor = 'white';
      container.style.borderRadius = '50%';
      container.style.border = '4px solid rgba(255, 255, 255, 1)';
      container.style.boxShadow = '0 0 20px rgba(59, 130, 246, 0.6)';
      container.style.position = 'relative';
      container.style.zIndex = '30';
      
      // Create an image element with enhanced styling
      const img = document.createElement('img');
      img.src = logo;
      img.alt = 'AUDIT-AI Logo';
      img.style.width = '85%'; // Slightly smaller than container to ensure proper fit
      img.style.height = '85%';
      img.style.objectFit = 'contain';
      img.style.borderRadius = '50%';
      img.style.position = 'relative';
      img.style.zIndex = '35';
      
      // Add the logo text
      const textContainer = document.createElement('div');
      textContainer.style.position = 'absolute';
      textContainer.style.bottom = '15%';
      textContainer.style.left = '0';
      textContainer.style.right = '0';
      textContainer.style.textAlign = 'center';
      textContainer.style.zIndex = '40';
      textContainer.style.fontWeight = 'bold';
      textContainer.style.fontSize = isMobile ? '14px' : '12px';
      textContainer.style.color = '#3b82f6';
      textContainer.textContent = 'AUDIT-AI';
      
      // Clear any existing children
      while (logoContainerRef.current.firstChild) {
        logoContainerRef.current.removeChild(logoContainerRef.current.firstChild);
      }
      
      // Build the component hierarchy
      container.appendChild(img);
      container.appendChild(textContainer);
      logoContainerRef.current.appendChild(container);
      
      // Add the pulsing animation
      const keyframes = `
        @keyframes logoPulse {
          0% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.5); }
          50% { box-shadow: 0 0 30px rgba(79, 70, 229, 0.7); }
          100% { box-shadow: 0 0 20px rgba(59, 130, 246, 0.5); }
        }
      `;
      
      // Add the animation to the container
        const styleElement = document.createElement('style');
        styleElement.id = 'logo-pulse-animation';
      styleElement.textContent = keyframes;
        document.head.appendChild(styleElement);
      
      container.style.animation = 'logoPulse 4s infinite ease-in-out';
    }
  }, [isMobile, logo]);

  return (
    <section
      id="secondary-features"
      aria-label="Features for automating compliance workflows"
      className="py-20 sm:py-32 relative overflow-hidden"
    >
      {/* Professional futuristic background - new improved design */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Clean gradient backdrop */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-blue-50 opacity-95"></div>
        
        {/* Professional geometric patterns */}
        <div className="absolute inset-0 opacity-5">
          <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
            <defs>
              <pattern id="grid-pattern" patternUnits="userSpaceOnUse" width="50" height="50">
                <path d="M 50 0 L 0 0 0 50" fill="none" stroke="rgba(59, 130, 246, 0.3)" stroke-width="0.5"></path>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid-pattern)" />
          </svg>
        </div>
        
        {/* Elegant dot pattern */}
        <div className="absolute inset-0 opacity-5">
          <svg width="100%" height="100%">
            <defs>
              <pattern id="dot-pattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                <circle cx="10" cy="10" r="1" fill="rgba(79, 70, 229, 0.4)" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#dot-pattern)" />
          </svg>
        </div>
        
        {/* Professional abstract accent elements */}
        <div className="absolute top-0 right-0 w-1/2 opacity-10">
          <svg viewBox="0 0 400 400" preserveAspectRatio="xMaxYMin meet">
            <circle cx="350" cy="50" r="25" fill="none" stroke="rgba(99, 102, 241, 0.6)" strokeWidth="1" />
            <circle cx="350" cy="50" r="15" fill="none" stroke="rgba(99, 102, 241, 0.6)" strokeWidth="1" />
            <line x1="310" y1="50" x2="330" y2="50" stroke="rgba(99, 102, 241, 0.6)" strokeWidth="1" />
            <line x1="370" y1="50" x2="390" y2="50" stroke="rgba(99, 102, 241, 0.6)" strokeWidth="1" />
            <line x1="350" y1="10" x2="350" y2="30" stroke="rgba(99, 102, 241, 0.6)" strokeWidth="1" />
            <line x1="350" y1="70" x2="350" y2="90" stroke="rgba(99, 102, 241, 0.6)" strokeWidth="1" />
          </svg>
        </div>
        
        <div className="absolute bottom-0 left-0 w-1/2 opacity-10">
          <svg viewBox="0 0 400 400" preserveAspectRatio="xMinYMax meet">
            <rect x="50" y="300" width="50" height="50" fill="none" stroke="rgba(59, 130, 246, 0.6)" strokeWidth="1" />
            <rect x="60" y="310" width="30" height="30" fill="none" stroke="rgba(59, 130, 246, 0.6)" strokeWidth="1" />
            <line x1="30" y1="325" x2="45" y2="325" stroke="rgba(59, 130, 246, 0.6)" strokeWidth="1" />
            <line x1="105" y1="325" x2="120" y2="325" stroke="rgba(59, 130, 246, 0.6)" strokeWidth="1" />
            <line x1="75" y1="280" x2="75" y2="295" stroke="rgba(59, 130, 246, 0.6)" strokeWidth="1" />
            <line x1="75" y1="355" x2="75" y2="370" stroke="rgba(59, 130, 246, 0.6)" strokeWidth="1" />
          </svg>
        </div>
      </div>
      
      <Container className="relative z-10">
        <div className="mx-auto max-w-3xl text-center relative px-2 sm:px-4">
          <div className="flex items-center justify-center gap-2 mb-3 mx-auto">
            <div className="h-px w-8 bg-blue-600/30"></div>
            <p className="text-blue-600 font-medium text-sm uppercase tracking-widest text-center whitespace-nowrap">Enterprise Solution</p>
            <div className="h-px w-8 bg-blue-600/30"></div>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 mb-4 relative z-10 text-center">
            The Complete <span className="gradient-text font-extrabold">Audit Automation</span> Platform
          </h2>
          <p className="mt-4 text-lg md:text-xl leading-relaxed text-gray-600 relative z-10 mx-auto px-4 py-4 bg-white/90 backdrop-blur-sm shadow-sm rounded-xl border border-slate-100/60 max-w-3xl">
            Transform how your organization approaches audit and compliance with AI-powered tools that eliminate manual processes and provide unprecedented insights.
          </p>
        </div>
        
        {/* Feature cards with improved design and scroll animation */}
        <ul
          role="list"
          className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 px-2 sm:px-4 sm:mt-20 sm:grid-cols-2 md:gap-x-8 md:gap-y-10 lg:max-w-none lg:grid-cols-3 relative z-10"
        >
          {features.map((feature, index) => (
            <li
              key={feature.name}
              ref={el => cardRefs.current[index] = el}
              data-index={index}
              className={`relative rounded-2xl p-6 sm:p-8 shadow-xl hover:shadow-2xl group transition-all duration-500 flex flex-col h-full mx-auto w-full will-change-transform ${
                visibleCards[index] 
                  ? 'opacity-100'
                  : 'opacity-0'
              }`}
              style={{ 
                boxShadow: '0 10px 30px -5px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.05), inset 0 0 0 1px rgba(148, 163, 184, 0.1)',
                transitionDelay: `${index * 100}ms`, // Staggered delay based on index
                transform: visibleCards[index] ? 'translateY(0)' : 'translateY(4rem)',
                opacity: visibleCards[index] ? 1 : 0,
                transition: 'transform 0.7s ease, opacity 0.7s ease, box-shadow 0.3s ease',
                WebkitFontSmoothing: 'antialiased',
                backfaceVisibility: 'hidden'
              }}
            >
              {/* Premium mobile card background */}
              <div className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none">
                {/* Modern premium gradient background */}
                <div className="absolute inset-0 bg-gradient-to-br from-white via-slate-50/80 to-blue-50/20"></div>
                
                {/* Premium glass effect - removed backdrop-blur that was causing blur issues */}
                <div className="absolute inset-0 bg-white/60"></div>
                
                {/* Subtle reflection effect */}
                <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-white/90 to-transparent"></div>
                
                {/* Modern shadow inner effect */}
                <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-blue-50/10 to-transparent"></div>
                
                {/* Ultra-subtle grain texture overlay */}
                <div className="absolute inset-0 opacity-[0.02]">
                  <svg width="100%" height="100%">
                    <filter id="noise">
                      <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="4" stitchTiles="stitch"></feTurbulence>
                    </filter>
                    <rect width="100%" height="100%" filter="url(#noise)"></rect>
                </svg>
              </div>
              
                {/* Premium shimmer effect */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-1000">
                  <div className="absolute -inset-[400%] bg-gradient-to-r from-transparent via-blue-100/10 to-transparent rotate-45 -translate-x-[100%] group-hover:translate-x-[500%] transition-transform duration-2000 ease-in-out"></div>
                </div>
              </div>
              
              {/* Premium accent stripe - modern touch */}
              <div className="absolute top-0 left-0 right-0 h-1 rounded-t-2xl bg-gradient-to-r from-blue-500/30 via-indigo-500/40 to-blue-600/30"></div>
              
              <div className="relative z-10 flex-1">
                {/* Premium icon container with elegant border and shadow */}
                <div className={`h-16 w-16 mb-6 relative will-change-transform ${
                  visibleCards[index] ? 'animate-icon-appear' : 'opacity-0 scale-0'
                }`} style={{ transitionDelay: `${(index * 100) + 200}ms` }}>
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-50 to-indigo-50 shadow-sm"></div>
                  
                  {/* Premium quality shadow */}
                  <div className="absolute -inset-1 rounded-xl bg-gradient-to-br from-blue-500/10 to-indigo-500/10 blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
                  
                  {/* Elegant icon background with subtle shadows */}
                  <div className="absolute inset-2 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-inner">
                    <div className="text-white transform scale-125">{feature.icon}</div>
                  </div>
                  
                  {/* Subtle ring highlight on hover */}
                  <div className="absolute -inset-1 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                    <div className="absolute inset-0 rounded-xl border border-blue-300/20"></div>
                  </div>
                </div>
                
                <h3 className={`${isMobile ? 'text-2xl' : 'text-xl'} font-bold text-gray-900 mb-3 relative group-hover:text-blue-600 transition-colors duration-300 will-change-transform ${
                  visibleCards[index] ? 'animate-text-appear' : 'opacity-0'
                }`} style={{ transitionDelay: `${(index * 100) + 300}ms` }}>
                  {/* Premium underline */}
                  <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-gradient-to-r from-blue-600 to-indigo-500 group-hover:w-16 transition-all duration-500"></span>
                  {feature.name}
                </h3>
                
                <p className={`${isMobile ? 'text-base' : 'text-sm'} text-gray-600 leading-relaxed will-change-opacity ${
                  visibleCards[index] ? 'animate-text-fade-in' : 'opacity-0'
                }`} style={{ transitionDelay: `${(index * 100) + 400}ms` }}>
                  {feature.description}
                </p>
                
                {/* Premium CTA with elegant styling and click functionality */}
                <div className="mt-4">
                  <div 
                    className={`inline-flex items-center transition-all duration-500 overflow-hidden cursor-pointer will-change-opacity ${
                      visibleCards[index] ? 'animate-cta-appear' : 'opacity-0 max-w-0'
                    }`} 
                    style={{ transitionDelay: `${(index * 100) + 500}ms` }}
                    onClick={handleExploreClick}
                  >
                    <span className="h-px w-8 bg-gradient-to-r from-blue-600/40 to-indigo-600/40 mr-3"></span>
                    <span className={`${isMobile ? 'text-base' : 'text-sm'} font-medium bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600`}>
                      Explore Feature
                    </span>
                  </div>
                </div>
              </div>
              
              {/* Premium border effect on interaction */}
              <div className="absolute inset-0 rounded-2xl pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-1000">
                <div className="absolute inset-0 rounded-2xl border border-indigo-200/50 shadow-[0_0_0_1px_rgba(79,70,229,0.05)]"></div>
              </div>
            </li>
          ))}
        </ul>
        
        {/* Gradient definitions for cards */}
        <svg width="0" height="0" className="hidden">
          <defs>
            <linearGradient id="card-accent-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgba(59, 130, 246, 0.05)" />
              <stop offset="50%" stopColor="rgba(79, 70, 229, 0.1)" />
              <stop offset="100%" stopColor="rgba(79, 70, 229, 0.2)" />
            </linearGradient>
          </defs>
        </svg>
        
     
      </Container>
    </section>
  )
} 